import { DatePipe, formatDate } from '@angular/common';

import {
  Component,
  Input,
  OnInit,
  ViewChild,
  SimpleChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { User } from '../header/header.component';

import { GridActionConfig, Notify } from 'dg-dynamic-grid-lib';
import { DEFAULT_DATA_PROP_CONFIG, InputType } from 'dg-input-lib';

import { AppInitService } from '../../services/app-init.service';

import { GenericApprovalService } from '../../services/generic-approval.service';
import { DgEmployeeSearchComponent } from 'dg-emp-search-lib';
import { MatDialog } from '@angular/material/dialog';
import { SaveDialogComponent } from './save-dialog/save-dialog.component';
import { post } from 'jquery';

@Component({
  selector: 'app-generic-approval',
  templateUrl: './generic-approval.component.html',
  styleUrls: ['./generic-approval.component.scss'],
})
export class GenericApprovalComponent implements OnInit {
  @ViewChild(DgEmployeeSearchComponent) empSearch: DgEmployeeSearchComponent;
  @Output() outputBack = new EventEmitter();
  @Output() outputRefresh = new EventEmitter();
  profileAttachTitle: any;
  minStartDate: Date;
  selectedEmployees: string;
  // orgConfig = {
  //   prntId: '70002298',
  //   fetchPrntOrgOnlyFlag: 'false',
  //   multiselect: false,
  //   header: 'Reporting Organization',
  //   minLengthForSearch: 3,
  //   minLengthMessage: 'Please enter 3 or more characters',
  // };
  empSearchConfig = {
    multiSelect: false,
    header: 'Reporting_Employee',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 char',
    selectedEmployeeList: null,
  };
  currentt: string;
  unitId: any;
  unitArray: any;
  address: any;
  selectedIndex: any;
  loginOrgId: any;
  loginOrgName: any;
  loginEmpName: unknown;
  subjectId: any;
  isSaveFlag = false;
  openEmpDialog(): void {
    setTimeout(() => {
      this.empSearch.openDialog();
    }, 100);
  }
  constructor(
    public translate: TranslateService,

    private datePipe: DatePipe,

    private appInitService: AppInitService,
    private generic: GenericApprovalService,
    private dialog: MatDialog
  ) {
    const currentDate = new Date();
    this.minStartDate = new Date(currentDate);
    if (this.isGenericAprCase) {
      this.appInitService?.getConfigurableFields()?.subscribe((res) => {
        this.subjectId = this.appInitService?.appConfig?.configurableFields?.GENERIC_APPROVAL_SUB_ID?.toString()?.trim();
      });
    }
  }
  current = new Date();
  profileAcceptedType = ['pdf', 'png', 'doc', 'docx', 'xlsx', 'txt', 'xls'];
  profileMaxSize = 200;
  profileUniqueAttachID = 'Data Syncronization';
  isAllowFileToAttachProfile = true;
  profileAttachID = '';
  purposeList = [];
  interfaceList = [];
  finalPath: any;
  expForm: FormGroup;
  processList = [];
  empConfig = {
    multiSelect: true,
    header: 'Select Hierarchy',
    subTitle: 'EmployeeHierarchy',
    selectedSubTitle: 'SelectedHierarchy',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters',
    btnText: 'submit',
  };

  orgConfig = {
    prntId: '54',
    fetchPrntOrgOnlyFlag: 'false',
    multiselect: false,
    header: 'Organization Search',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters ',
  };

  @Input('isGenericAprCase') isGenericAprCase: boolean = true;
  @Input('process') process = null;
  @Input('caseDesc') caseDesc = null;
  ngOnInit(): void {
    this.translate.get('Data_sync.Upload').subscribe((res) => {
      this.profileAttachTitle = res;
    });
    this.currentt = formatDate(this.current, 'dd-MM-yyyy', 'en-US');
    if (!this.isGenericAprCase) {
      this.subjectId = Number(this.process?.optionValue);
    }
    this.expForm = new FormGroup({
      background: new FormControl(null, [
        Validators.required,
        Validators.maxLength(2000),
      ]),
      transaction: new FormControl(null, [
        Validators.required,
        Validators.maxLength(2000),
      ]),
      budget: new FormControl(null, [
        Validators.required,
        Validators.maxLength(500),
      ]),
      nature: new FormControl(null, [
        Validators.required,
        Validators.maxLength(500),
      ]),
      subject: new FormControl(this.isGenericAprCase ? null : this.process, [
        Validators.required,
        Validators.maxLength(100),
      ]),
      process: new FormControl(null),
      ps: new FormControl(null),
      name: new FormControl(null),
      pran: new FormControl(null),
      currentDate: new FormControl(null),
      time: new FormControl(null),
      reportingEmpId: new FormControl(null),
      reportingEmp: new FormControl(null),
      startDate: new FormControl(null),
      startTime: new FormControl(null),
      purpose: new FormControl(null),
      description: new FormControl(null),
      attachFile: new FormControl(null),
    });

    this.expForm.controls.ps.disable();
    this.expForm.controls.name.disable();
    this.expForm.controls.pran.disable();
    this.expForm.controls.currentDate.disable();
    this.expForm.controls.time.disable();
    this.expForm.controls.currentDate.setValue(this.currentt);

    this.expForm.controls.ps.setValue('Bhaktiarpur CPI');
    this.expForm.controls.time.setValue(
      formatDate(this.current, 'HH:MM', 'en-US')
    );
    this.checkValidation();

    this.generic.methodForLoginDetails().subscribe((res: User) => {
      const restemp: User = res;
      this.unitId = restemp?.employeeVO?.unitId;
      this.unitArray = restemp?.employeeVO?.unitVO;
      this.loginEmpName = restemp?.employeeVO?.empFullName;

      this.expForm.controls.pran.setValue(restemp?.employeeVO?.empId);
      this.expForm.controls.name.setValue(restemp?.employeeVO?.empFullName);
      this.Calculate();
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.isGenericAprCase) {
      this.appInitService?.getConfigurableFields()?.subscribe((res) => {
        this.subjectId = this.appInitService?.appConfig?.configurableFields?.GENERIC_APPROVAL_SUB_ID?.toString()?.trim();
      });
    } else {
      if (this.process) {
        this.subjectId = Number(this.process?.optionValue);
      }
    }
  }
  onStepChange(data): void {
    console.log('On Step Change', data);
    this.selectedIndex = data?.selectedIndex;
  }
  onStepClick(i): void {
    this.selectedIndex = i;
  }
  onNextStep(i, type?: number): void {
    this.selectedIndex = i;
    if (!this.isGenericAprCase && i == 0) this.outputBack.emit(true);
  }
  getData2(val): void {
    let unitIds = val?.map((employee) => employee?.UNIT_ID);
    this.empSearch.selectedEmployeeList = unitIds;
    this.accessRows = [];
    val.forEach((empDetails, i) => {
      this.accessRows.push({
        activityOrder: i + 1,
        employee: {
          value: empDetails,
          cellConfig: {
            configAtRowLevel: true,
            columnId: 'employee',
            width: 75,
            displayable: true,
            sortable: false,
            type: 27,
            columnName: 'Employee Name',
            empConfig: {
              multiSelect: false,
              header: 'Reporting_Employee',
              minLengthForSearch: 3,
              minLengthMessage: 'Please enter 3 char',
              selectedEmployeeList: [empDetails.UNIT_ID.toString()],
              //     orgId: this.loginOrgId,
            },
            renderPath: 'FULL_NAME',
          },
        },
        isApprover: {
          optionValue: 0,
          optionText: '--',
        },
      });
      // this.accessRows[i].employee.value = empDetails;
      // this.accessRows[i].activityOrder = i + 1;
    });
    this.accessRows[val.length - 1].isApprover = {
      optionValue: 1,
      optionText: 'Yes',
    };
    this.accessRows = [...this.accessRows];
  }
  Calculate() {
    this.unitArray?.forEach((unit) => {
      if (this.unitId == unit?.unitId) {
        this.loginOrgId = unit?.deptId;
        unit?.organizationVOArr.forEach((org) => {
          this.loginOrgName = org.organizationName;
          // this.empSearch.orgId = this.loginOrgId;
          this.getAccessGrid();
        });
        return;
      }
    });
  }

  getEmpData(val) {
    this.selectedEmployees = JSON.stringify(val);
    console.log('data in emp-search test', JSON.stringify(val));
    this.expForm.controls['reportingEmp'].setValue(val.POST_ID);
    this.expForm.controls['reportingEmpId'].setValue(val.EMP_ID);
  }
  onChange(e) {
    console.log('on Change event Worked in application', e);
  }
  onFinalPathForProfile(finalPath: Event): void {
    this.finalPath = finalPath;
    this.expForm.controls.attachFile.setValue(this.finalPath);
  }
  onFinalPath(path) {
    this.finalPath = path;
    this.expForm.controls.attachFile.setValue(this.finalPath);
  }
  checkValidation() {
    if (this.expForm.valid) return false;
    else return true;
  }

  onSaveDialog(flag: boolean) {
    let callApi = false;
    const dialogDeleteFolder = this.dialog.open(SaveDialogComponent, {
      // width: '30vw',
      // height: '70vw',
      data: flag,
    });
    dialogDeleteFolder.afterClosed().subscribe((result) => {
      if (result) {
        callApi = result;
        //      this.getFolderTreeData();
        // window.location.reload();
        if (callApi) {
          let postData = {
            returnCaseObjAfterCaseCreation: !this.isGenericAprCase
              ? true
              : false,
            saveFlag: flag,
            bgDtl: this.expForm.controls['background'].value,
            trnDtl: this.expForm.controls['transaction'].value,
            expenseDtl: this.expForm.controls['budget'].value,
            docDtl: this.expForm.controls['nature'].value,
            subjDtl: this.expForm.controls['subject'].value,
            isGenericAprCase: this.isGenericAprCase,
            attachmentReference: this.finalPath,
            caseDesc: this.caseDesc,
            hierarchyConfigVO: {
              subId: this.subjectId,
              lsbName: this.isGenericAprCase
                ? 'Generic Approval'
                : this.process.optionText,
              lsbDescription: this.isGenericAprCase
                ? 'Generic Approval'
                : this.process.optionText,
              TypeFlagId: 656,
              stageId: null,
              orgIdArr: [this.loginOrgId],
            },
            adminVOs: [
              {
                nextOrder: null,
                previousOrder: 0,
                deleteListAdminVOs: [],
                lgSubId: null,
                typeId: 656,
                lsbPk: null,
                techniqueId: 2,
                isApprover: false,
                subId: this.subjectId,
                listAdminVOs: [
                  {
                    unitId: this.unitId,
                    empName: this.loginEmpName,
                    isDefault: 1,
                    ruleExpression: null,
                    approveRuleExpression: null,
                    mobileViewExpanded: true,
                    _dynamicRowIndex: '187240df-9c1f-4d6d-9fbe-926f243700fd',
                    ruleMpgVOLst: [
                      { ruleCode: null, type: 30001, isDefault: 1 },
                    ],
                    rule: null,
                  },
                ],
                stageId: null,
                chckLstCompId: null,
                wfmsEventNtfcMpgVOs: [],
                subName: null,
                organizationName: this.loginOrgName,
                organizationId: this.loginOrgId,
                workflowActionVOs: null,
                subPrivId: null,
              },
            ],
          };
          let adminVoJson = {
            nextOrder: null,
            previousOrder: 0,
            deleteListAdminVOs: [],
            lgSubId: null,
            typeId: 656,
            lsbPk: null,
            techniqueId: 2,
            isApprover: false,
            subId: this.subjectId,
            listAdminVOs: [
              {
                unitId: null,
                empName: null,
                isDefault: 1,
                ruleExpression: null,
                approveRuleExpression: null,
                mobileViewExpanded: true,
                _dynamicRowIndex: '187240df-9c1f-4d6d-9fbe-926f243700fd',
                ruleMpgVOLst: [{ ruleCode: null, type: 30001, isDefault: 1 }],
                rule: null,
              },
            ],
            stageId: null,
            chckLstCompId: null,
            wfmsEventNtfcMpgVOs: [],
            subName: null,
            organizationName: this.loginOrgName,
            organizationId: this.loginOrgId,

            workflowActionVOs: null,
            subPrivId: null,
          };
          this.accessRows?.forEach((row, i) => {
            adminVoJson.previousOrder = Number((i + 1) * 1000);
            adminVoJson.listAdminVOs[0].empName =
              row?.employee?.value?.FULL_NAME;
            adminVoJson.listAdminVOs[0].unitId = row?.employee?.value?.UNIT_ID;
            if (row.isApprover.optionValue == 1) {
              adminVoJson.isApprover = true;
            } else {
              adminVoJson.isApprover = false;
            }
            adminVoJson = JSON.parse(JSON.stringify(adminVoJson));
            //   postData.adminVO.push(adminVoJson);
            postData.adminVOs = [
              ...postData.adminVOs,
              JSON.parse(JSON.stringify(adminVoJson)),
            ];
          });
          console.log('Submit Json', postData);
          // postData.adminVOs = null;
          // postData.hierarchyConfigVO = null;
          this.generic.createNewProcess(postData).subscribe((res: any) => {
            if (res?.data)
              setTimeout(() => {
                if (!this.isGenericAprCase) {
                  this.outputRefresh.emit(res);
                } else {
                  window.location.reload();
                }
              }, 100);
          });
        }
      }
    });
  }

  onSave() {
    this.onSaveDialog(true);
  }
  onSubmit() {
    this.onSaveDialog(false);
  }

  accessCols = [];
  pageSize = 5;
  addRowAtTop = false;
  showSearch = false;

  actionList: GridActionConfig[] = [
    // {
    //   actionName: 'add',
    //   actionLabel: 'Add Employee',
    //   actionDescription: 'You can add Employee using this button.',
    //   actionIcon: 'add',
    //   isPrimary: true,
    //   isVisible: true,
    //   isDisabled: false,
    // },
  ];
  accessRows = [];
  folderId = 1000015328;
  name = '';

  colPropConfig = DEFAULT_DATA_PROP_CONFIG;

  RQUIRED_VAL_JSON = {
    id: 0,
    async: false,
    type: 'required',
    value: null,
    errorMessage: 'This field is required',
  };
  activityOrderIndex = 1;
  getAccessGrid(): void {
    this.accessCols = [
      // {
      //   columnId: 'rowCount',
      //   width: 10,
      //   displayable: true,
      //   sortable: false,
      //   type: 1,
      //   align: 'left',
      //   columnName: 'Row Count',
      // },
      {
        // configAtRowLevel: true,
        columnId: 'activityOrder',
        width: 10,
        displayable: true,
        sortable: false,
        type: null,
        align: 'left',
        searchable: false,
        columnName: 'Level',

        defaultValue: null,
      },
      // {
      //   columnId: 'unitId',
      //   width: 75,
      //   displayable: true,
      //   sortable: true,
      //   type: 50,
      //   columnName: 'Employee Name',
      // },
      {
        configAtRowLevel: true,
        columnId: 'employee',
        width: 75,
        displayable: true,
        sortable: false,
        type: InputType.EMP_SEARCH,
        columnName: 'Employee Name',
        empConfig: {
          multiSelect: false,
          header: 'Reporting_Employee',
          minLengthForSearch: 3,
          minLengthMessage: 'Please enter 3 char',
          selectedEmployeeList: null,
          //  orgId: this.loginOrgId,
        },
      },
      {
        // configAtRowLevel: true,
        columnId: 'isApprover',
        defaultValue: {
          optionValue: 0,
          optionText: '--',
        },
        width: 50,
        displayable: true,
        comboItems: [
          {
            optionValue: 1,
            optionText: 'Yes',
          },
          {
            optionValue: 0,
            optionText: '--',
          },
        ],
        sortable: false,
        type: 18,
        align: 'left',
        columnName: 'Final Approver',
      },
      // {
      //   headerAlign: 'center',
      //   actionConfig: [
      //     {
      //       actionIcon: 'save',
      //       isVisible: false,
      //       isDisabled: true,
      //       actionName: 'save',
      //     },
      //     {
      //       actionIcon: 'close',
      //       isVisible: false,
      //       isDisabled: false,
      //       actionName: 'close',
      //     },

      //     {
      //       actionIcon: 'edit',
      //       isVisible: true,
      //       isDisabled: false,
      //       actionName: 'edit',
      //     },
      //     {
      //       actionIcon: 'delete',
      //       isVisible: true,
      //       isDisabled: false,
      //       actionName: 'delete',
      //     },
      //   ],
      //   columnId: 'actions',
      //   configAtRowLevel: true,
      //   width: 1,
      //   displayable: true,
      //   sortable: false,
      //   icons: true,
      //   align: 'center',
      //   columnName: 'Actions',
      // },
    ];
  }
  updateActionsatRow(row, index: number = -1): any {
    let isDefault: boolean;
    let actionConfig = [];
    if (index === 0) {
      row.isDefault = 1;
    }
    if (row?.isDefault === 1) {
      isDefault = true;
    } else {
      isDefault = false;
    }

    actionConfig = [
      {
        actionIcon: 'edit',
        isVisible: true,
        isDisabled: false,
        actionName: 'edit',
      },
      {
        actionIcon: 'delete',
        isVisible: true,
        isDisabled: false,
        actionName: 'delete',
      },
    ];

    const cellConfig = {
      headerAlign: 'center',
      columnId: 'actions',
      configAtRowLevel: true,
      width: 10,
      displayable: true,
      sortable: false,
      align: 'center',
      icons: true,
      columnName: 'Actions',
      actionConfig: actionConfig,
    };
    const cell = {
      cellConfig: cellConfig,
    };
    row.actions = cell;
    return row;
  }
  onAccessActionPerformed({ row, action, rowIndex, notifier }): void {
    let notify: Notify;
    let roleFlag = Number(row?.accessTo?.value?.optionValue);

    let dataForPost = {
      privId: this.folderId,
      roleId: row?.roleId ? row?.roleId : null,
      roleFlag: roleFlag ? roleFlag : null,
      aclId: Number(row?.accessControl?.optionValue),
      strEndDate: row?.validityDate
        ? this.datePipe.transform(row?.validityDate, 'YYYY-MM-dd HH:mm:SS')
        : null,
      rlGrpPk: row?.rlGrpPk ? row?.rlGrpPk : null,
    };
    switch (action) {
      case 'edit':
        if (row?.validityDate) {
          row.validityDate = new Date(row?.validityDate);
        }

        notify = { status: -1, data: { ...row } };
        notifier?.next(notify);
        break;

      case 'create':
        row.employee.cellConfig.empConfig['selectedEmployeeList'] = [
          row.employee.value[0].UNIT_ID.toString(),
        ];
        row.employee.value = row.employee.value[0];
        if (row.isApprover.value.optionValue == 1) {
          this.accessRows?.forEach((row2, i) => {
            if (i != rowIndex) {
              // row2.isApprover.cellConfig.type = null;
              //   row2.isApprover.cellConfig.defaultValue = null;
              row2.isApprover.cellConfig.value = {
                optionValue: 0,
                optionText: 'No',
              };
              row2.isApprover.value = {
                optionValue: 0,
                optionText: 'No',
              };
            }
          });
          // this.accessCols?.forEach((col2, i) => {
          //   if (col2.columnId == 'isApprover') {
          //     // row2.isApprover.cellConfig.type = null;
          //     col2.defaultValue = null;
          //   }
          // });
        }

        // this.accessCols[0].defaultValue = this.accessRows?.length + 1;

        this.accessRows = this.addRowAtTop
          ? [row, ...this.accessRows]
          : [...this.accessRows, row];
        // if (this.accessRows.length > 1)
        //   this.accessRows?.forEach((row2, i) => {
        //     if (row2.isApprover.value.optionValue == 1) {
        //       this.accessRows.push(this.accessRows.splice(i, 1)[0]);
        //     }
        //   });

        // row.activityOrder.value = this.accessRows?.length + 1;
        this.accessRows?.forEach((row2, i) => {
          row2.activityOrder = i + 1;
        });
        //  row.activityOrder.cellConfig.defaultValue = this.accessRows?.length + 2;
        this.accessRows = [...this.accessRows];
        notify = { status: 1, data: { row } };
        notifier?.next(notify);

        break;
      case 'update':
        if (row?.employee?.value[0]) {
          row.employee.cellConfig.empConfig['selectedEmployeeList'] = [
            row.employee.value[0].UNIT_ID.toString(),
          ];
          row.employee.value = row?.employee?.value[0];
        } else if (row.employee.value.UNIT_ID) {
          row.employee.cellConfig.empConfig['selectedEmployeeList'] = [
            row.employee.value.UNIT_ID.toString(),
          ];
          row.employee.value = row?.employee?.value;
        }
        if (row.isApprover.value.optionValue == 1) {
          this.accessRows?.forEach((row2, i) => {
            if (i != rowIndex) {
              // row2.isApprover.cellConfig.type = null;
              //   row2.isApprover.cellConfig.defaultValue = null;
              row2.isApprover.cellConfig.value = {
                optionValue: 0,
                optionText: 'No',
              };
              row2.isApprover.value = {
                optionValue: 0,
                optionText: 'No',
              };
            }
          });
          // this.accessCols?.forEach((col2, i) => {
          //   if (col2.columnId == 'isApprover') {
          //     // row2.isApprover.cellConfig.type = null;
          //     col2.defaultValue = null;
          //   }
          // });
        }
        this.accessRows[rowIndex] = {
          ...this.accessRows[rowIndex],
          ...row,
        };
        // postData = this.rows[rowIndex];
        this.accessRows[rowIndex] = row;
        this.accessRows = [...this.accessRows];
        // if (this.accessRows.length > 1)
        //   this.accessRows?.forEach((row2, i) => {
        //     if (row2.isApprover.value.optionValue == 1) {
        //       this.accessRows.push(this.accessRows.splice(i, 1)[0]);
        //     }
        //   });
        //     this.dynamicGrid?.refreshCols();
        notify = { status: 1, data: { ...row } };
        notifier?.next(notify);

        break;
      case 'delete':
        this.accessRows.splice(rowIndex, 1);
        this.accessRows.join();
        this.accessRows?.forEach((row, i) => {
          row.activityOrder = i + 1;
        });
        //  this.accessCols[0].defaultValue = this.accessRows?.length + 1;
        this.accessRows = [...this.accessRows];

        notify = { status: 1, data: { row } };
        notifier?.next(notify);
        console.log(`${action} successful`);

        break;
    }
  }

  onCustomOutput({ customComponentOutput, row, rowIndex, col, form }): void {
    customComponentOutput.forEach((output) => {
      if (output?.from === 'output') {
        form.controls?.unitId.setValue(output?.data);
        row.roleId = output?.data;
      }
    });
  }

  onInputChange = ({
    data,
    currentValue,
    form,
    formControlVaule,
    row,
    rowIndex,
    notifier,
  }) => {
    if (currentValue?.unitId) {
      form?.controls?.empName?.setValue(currentValue?.empName);
      form?.controls?.unitId?.setValue(currentValue);
      let notify: Notify;
      row?.actions?.cellConfig?.actionConfig?.forEach((el) => {
        if (el?.actionName === 'save') {
          el.isDisabled = false;
        }
      });
      row.unitId.value = { ...currentValue };
      notify = { status: -1, data: { ...row } };
      notifier?.next(notify);
    }
    this.accessCols[0].defaultValue = this.accessRows?.length + 1;
    if (currentValue[0]?.UNIT_ID) {
      row?.actions?.cellConfig?.actionConfig?.forEach((el) => {
        if (el?.actionName === 'save') {
          el.isDisabled = false;
        }
      });
    }
  };
}
